import React, {useContext, useEffect, useState} from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import {Col, Container, Image, Row, Button, Form, FloatingLabel, Card} from "react-bootstrap";
import LoginForm from "../forms/LoginForm";
import OTPemailForm from "../forms/OTPemailForm";
import {useToolkit} from "../../hooks/useToolkit";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";

/*<Col sm={4} className='content-left-wrapper'>
                    <LoginForm />
                </Col>*/

const Landing = () => {

    const { removeCurrentTab, removeCurrentQuote } = useToolkit();
    const { removeAppUniqueToken } = useAppUniqueToken();

    useEffect(() => {
        removeCurrentTab();
        removeCurrentQuote();
        //removeAppUniqueToken();
    }, []);

    return (
            <Container fluid>
                <Row className={'row-height text-danger'}>
                    <Col  className='content-left-wrapper' >
                        <Container fluid className="text-black">
                            <Image src={'img/europaverde.png'} alt='europaverde_logo' width='150px' />
                            <h2>Tesseramento multiplo</h2>
                            <p>
                            
                                In questa sezione è possibile inserire richieste di adesione multiple per la tua Regione/Provincia/Associazione.<br />
                                Il pagamento delle richieste di adesione dovrà pervenire tramite bonifico bancario.<br />
                                Il sistema permette di inserire richieste di adesione solo per le aree legate alla propria carica.<br />
                                Le richieste di adesione di persone non residenti nell'area a voi legata non potranno essere inviate tramite questo sistema.
                            
                            </p>
                            <Container className="content-left-wrapper">
                                <OTPemailForm />
                            </Container>
                        </Container>
                    </Col>

                </Row>
            </Container>
    );
};

export default Landing;
